import { render, staticRenderFns } from "./PlayerNotes.vue?vue&type=template&id=62e552d8"
import script from "./PlayerNotes.vue?vue&type=script&lang=js"
export * from "./PlayerNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports